import { toZonedTime } from 'date-fns-tz'
import { createParser } from 'nuqs'
import { getLocalTimezone } from 'lib/time'

function compareDates(a: Date, b: Date) {
  return a.valueOf() === b.valueOf()
}

// nuqs parser for date-only URL query params (e.g. `?start-date=2024-01-01`); the parsed value is a Date at midnight in the user's local timezone.
export const parseAsZonedDate = createParser({
  parse: (v) => {
    const date = new Date(v.slice(0, 10))
    if (Number.isNaN(date.valueOf())) {
      return null
    }
    return toZonedTime(v, getLocalTimezone())
  },
  serialize: (v: Date) =>
    toZonedTime(v, getLocalTimezone()).toISOString().slice(0, 10),
  eq: compareDates,
})
